import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { i18nInstance as globalNavI18n } from '@mc/global-navigation'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG, GLOBAL_NAV_I18N_NS } from '../constants'

/**
 * Variant copy for flw-1235_v2, or `undefined` outside the variant, plus
 * exposure.
 *
 * Only `variant_1` returns a string — control, flag-off and any unknown future
 * bucket all return `undefined` so callers fall back to their existing copy.
 *
 * Both the top bar and the mobile menu call this; `trackExperimentViewed`
 * de-dupes Experiment Viewed in production, so that yields one exposure.
 */
export const useEnterpriseNavCtaOverride = () => {
  const bucket = useBucket<'control' | 'variant_1'>(EXPERIMENT_FLAG)

  useEffect(() => {
    trackExperimentViewed(EXPERIMENT_FLAG)
  }, [bucket])

  if (bucket !== 'variant_1') {
    return undefined
  }

  return globalNavI18n.t('nav.cta.flw1235_enterprise', {
    ns: GLOBAL_NAV_I18N_NS,
  })
}

/**
 * As `useEnterpriseNavCtaOverride`, for surfaces that hold their own control
 * copy and need a definite string to render.
 */
export const useEnterpriseNavCta = (controlCopy: string) =>
  useEnterpriseNavCtaOverride() ?? controlCopy
